type Props = { readonly size?: number };

export const MorphoIcon = ({ size = 16 }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 74 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M8.64066 46.6257V66.4908C8.64066 67.7137 9.67561 68.2213 9.99759 68.3366C10.3196 68.4751 11.4005 68.775 12.3664 67.8752L27.3944 53.4333C28.6742 52.2036 29.9093 50.9109 30.8375 49.3984C31.2744 48.6874 31.4555 48.2869 31.4555 48.2869C32.3755 46.418 32.3755 44.6184 31.4782 42.8187C30.1448 40.1424 26.7407 37.4198 21.6118 34.8357L12.8494 39.7271C10.2506 41.2037 8.64066 43.8109 8.64066 46.6257Z"
      fill="currentColor"
      fillOpacity={0.8}
    />
    <path
      d="M0 2.44212V23.2764C0 25.8835 1.74794 28.1907 4.23184 28.929C12.6954 31.3747 27.4375 36.6351 31.0024 44.3644C31.462 45.3795 31.7381 46.3717 31.8307 47.4099C34.1994 43.0954 35.2803 38.1348 34.7744 33.1051C34.0841 25.9758 30.3122 19.4925 24.4248 15.3626L3.42686 0.66555C3.05883 0.388682 2.62187 0.250244 2.1849 0.250244C1.81688 0.250244 1.4949 0.319463 1.14994 0.504042C0.459945 0.896269 0 1.61152 0 2.44212Z"
      fill="currentColor"
    />
    <path
      d="M64.5352 46.6257V66.4908C64.5352 67.7137 63.5006 68.2213 63.1782 68.3366C62.8567 68.4751 61.775 68.775 60.8095 67.8752L45.4317 53.0975C44.3849 52.0913 43.3853 51.0273 42.5968 49.808C41.9723 48.843 41.7206 48.2869 41.7206 48.2869C40.8005 46.418 40.8005 44.6184 41.697 42.8187C43.0312 40.1424 46.4354 37.4198 51.5635 34.8357L60.3263 39.7271C62.9484 41.2037 64.5352 43.8109 64.5352 46.6257Z"
      fill="currentColor"
      fillOpacity={0.8}
    />
    <path
      d="M73.19 2.44065V23.2749C73.19 25.882 71.4416 28.1892 68.9576 28.9276C60.4944 31.3732 45.7524 36.6337 42.1875 44.3629C41.7271 45.3781 41.451 46.3702 41.3592 47.4085C38.9905 43.094 37.9096 38.1334 38.4155 33.1037C39.1049 25.9743 42.8769 19.4911 48.7651 15.3611L69.7631 0.664077C70.131 0.387209 70.5679 0.248779 71.0047 0.248779C71.3726 0.248779 71.695 0.317998 72.0393 0.502577C72.7295 0.894804 73.19 1.61005 73.19 2.44065Z"
      fill="currentColor"
    />
  </svg>
);
